module.exports = __webpack_public_path__ + "img/banner.21ced1e1.jpg";